var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M9.33325 12C9.33325 10.5273 10.5272 9.33337 11.9999 9.33337H19.9999C21.4727 9.33337 22.6666 10.5273 22.6666 12V20C22.6666 21.4728 21.4727 22.6667 19.9999 22.6667H11.9999C10.5272 22.6667 9.33325 21.4728 9.33325 20V12Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3333 13.3334C18.3333 13.8857 17.8855 14.3334 17.3333 14.3334L14.6666 14.3334C14.1143 14.3334 13.6666 13.8857 13.6666 13.3334C13.6666 12.7811 14.1143 12.3334 14.6666 12.3334L17.3333 12.3334C17.8855 12.3334 18.3333 12.7811 18.3333 13.3334Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 3.66669C9.18845 3.66669 3.66663 9.18851 3.66663 16C3.66663 16.5523 3.21891 17 2.66663 17C2.11434 17 1.66663 16.5523 1.66663 16C1.66663 8.08394 8.08388 1.66669 16 1.66669C20.0311 1.66669 23.6736 3.3316 26.2769 6.00863L27.0512 3.684C27.2257 3.16002 27.792 2.87673 28.316 3.05127C28.84 3.2258 29.1232 3.79206 28.9487 4.31604L27.6164 8.31604C27.4988 8.66884 27.1953 8.92729 26.8282 8.98703C26.4612 9.04677 26.0914 8.89792 25.868 8.6006C23.6162 5.60271 20.0343 3.66669 16 3.66669ZM29.3333 15C29.8856 15 30.3333 15.4477 30.3333 16C30.3333 23.9161 23.916 30.3334 16 30.3334C11.9688 30.3334 8.32629 28.6684 5.72302 25.9914L4.94871 28.316C4.77418 28.84 4.20792 29.1233 3.68394 28.9488C3.15996 28.7742 2.87667 28.208 3.05121 27.684L4.38356 23.684C4.50108 23.3312 4.80464 23.0727 5.17167 23.013C5.53869 22.9533 5.90856 23.1021 6.13188 23.3994C8.38369 26.3973 11.9656 28.3334 16 28.3334C22.8115 28.3334 28.3333 22.8115 28.3333 16C28.3333 15.4477 28.781 15 29.3333 15Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.c023e6ceb24cb777d2e8ceb9a004045a.svg";
export { ForwardRef as ReactComponent };